module.exports = __webpack_public_path__ + "static/media/venmo-icon.a10dc9c8.svg";